var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCreditcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.833 0.697998H4.167C3.06242 0.699321 2.00345 1.13863 1.2223 1.91959C0.441151 2.70055 0.00158777 3.75942 0 4.864L0 23.198C0.00158777 24.3026 0.441151 25.3614 1.2223 26.1424C2.00345 26.9234 3.06242 27.3627 4.167 27.364H35.833C36.9376 27.3627 37.9966 26.9234 38.7777 26.1424C39.5588 25.3614 39.9984 24.3026 40 23.198V4.864C39.9984 3.75942 39.5588 2.70055 38.7777 1.91959C37.9966 1.13863 36.9376 0.699321 35.833 0.697998ZM38.333 23.198C38.333 24.576 37.212 25.698 35.833 25.698H4.167C3.5042 25.6972 2.86878 25.4336 2.40011 24.9649C1.93144 24.4962 1.66779 23.8608 1.667 23.198V4.864C1.667 3.486 2.788 2.364 4.167 2.364H35.833C37.212 2.364 38.333 3.486 38.333 4.864V23.198Z",
    fill: "#3E7D23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0472 21.688C34.2987 21.688 35.3133 20.6735 35.3133 19.422C35.3133 18.1705 34.2987 17.156 33.0472 17.156C31.7958 17.156 30.7812 18.1705 30.7812 19.422C30.7812 20.6735 31.7958 21.688 33.0472 21.688Z",
    stroke: "#3E7D23",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5473 21.688C31.7987 21.688 32.8133 20.6735 32.8133 19.422C32.8133 18.1705 31.7987 17.156 30.5473 17.156C29.2958 17.156 28.2812 18.1705 28.2812 19.422C28.2812 20.6735 29.2958 21.688 30.5473 21.688Z",
    stroke: "#3E7D23",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.167 5.69799H0.833C0.612329 5.69825 0.400757 5.78596 0.244625 5.94191C0.088493 6.09785 0.00052903 6.30932 0 6.52999L0 11.53C0 11.99 0.373 12.363 0.833 12.363H39.167C39.627 12.363 40 11.99 40 11.53V6.52999C39.9997 6.30915 39.9119 6.09742 39.7557 5.94126C39.5996 5.7851 39.3878 5.69726 39.167 5.69699V5.69799ZM38.333 10.698H1.667V7.36399H38.333V10.698ZM15.833 17.364H5.833C5.61694 17.3715 5.41223 17.4626 5.26203 17.6181C5.11183 17.7736 5.02787 17.9813 5.02787 18.1975C5.02787 18.4137 5.11183 18.6214 5.26203 18.7769C5.41223 18.9324 5.61694 19.0235 5.833 19.031H15.833C16.0491 19.0235 16.2538 18.9324 16.404 18.7769C16.5542 18.6214 16.6381 18.4137 16.6381 18.1975C16.6381 17.9813 16.5542 17.7736 16.404 17.6181C16.2538 17.4626 16.0491 17.3715 15.833 17.364ZM15.833 20.698H5.833C5.61913 20.7085 5.41749 20.8008 5.26984 20.9559C5.12218 21.1109 5.03983 21.3169 5.03983 21.531C5.03983 21.7451 5.12218 21.951 5.26984 22.1061C5.41749 22.2612 5.61913 22.3535 5.833 22.364H15.833C16.0469 22.3535 16.2485 22.2612 16.3962 22.1061C16.5438 21.951 16.6262 21.7451 16.6262 21.531C16.6262 21.3169 16.5438 21.1109 16.3962 20.9559C16.2485 20.8008 16.0469 20.7085 15.833 20.698Z",
    fill: "#3E7D23"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 28,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditcard);
export default __webpack_public_path__ + "static/media/creditcard.cef3e6a7e1552bc867a1d86242cbdf8d.svg";
export { ForwardRef as ReactComponent };